// App.js
import React, { useState, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Link,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import BottomTab from "./pages/BottomTab";
import LoginPage from "./pages/LoginPage";
import LandingPage from "./pages/LandingPage";
import ShowGraph from "./pages/ShowGraph";
import Tab1 from "./pages/Tab1";
import PrescriptionList from "./pages/PrescriptionList";
import Logout from "./pages/LogOut";
import ChiefComplaints from "./pages/ChiefComplaints3";
import "./styles/bottomtab.css";
import Prescription from "./pages/Prescription";
import RecordAudio from "./components/RecordAudio";
//import { lazyLoad } from './lazyLoad';
import MedicalDocument from "./pages/MedicalDocuments";
import WellnessPages from "./pages/WellnessPages";
import WellnessPage from "./pages/WellnessPage";
import VisualizeWellnessData from "./pages/VisualizeWellnessData";
import BrowseHealthCategories from "./pages/BrowseHealthCategories";
import Heart from "./pages/HealthCategories/Heart";
import Activity from "./pages/HealthCategories/Activity";
import Nutrition from "./pages/HealthCategories/Nutrition";
import VisualizeNutritionData from "./pages/VisualizeNutritionData";
import Sleep from "./pages/HealthCategories/Sleep";
import Recovery from "./pages/HealthCategories/Recovery";
import SkinDisease from "./pages/MedicalCategories/SkinDisease";
import ReportsList from "./pages/ReportsList";
import ReportList from "./pages/ReportList";
import ReportPrint from "./pages/ReportPrint";
import RegistrationPage from "./pages/RegistrationPage";
import Vitals from "./pages/Vitals";
import BP from "./pages/BP";
import Chat from "./pages/Chat2";
import QuestionnaireFormIntake from "./pages/QuestionnaireFormIntake2";
import PregnancyRealTimeRiskEvalIntake from "./pages/PregnancyRealTimeRiskEvalIntake3";
import CameraCapture from "./pages/CameraCapture";
import MedicineList from "./pages/MedicineList";
import SideBar from "./components/SideBar";
import MobileNav from "./components/MobileNav";
import Payment from "./pages/Payment";
import ConsultDoctor from "./pages/ConsultDoctor";
import VisualizaSummaryData from "./components/VisualizaSummaryData";
import Profile from "./pages/Profile";
import Owner from "./pages/Owner";
import OwnerLanding from "./pages/OwnerLanding";
import VisualizeWellnessDataForOwner from "./pages/VisualizeWellnessDataForOwner";
import VisualizeExerciseDataForOwner from "./pages/VisualizeExerciseDataForOwner";
import Email from "./pages/Email";
import Products from "./pages/Products";
import EnergyBandSales from "./pages/EnergyBand-sales";
import SemStethoSales from "./pages/semStetho-sales";
import PaymentResult from "./pages/PaymentResult";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailure from "./pages/PaymentFailure";
import OnExam from "./pages/OnExam";
import Stetho from "./pages/Stetho";
import VideoExam from "./pages/VideoExam";
//https://www.youtube.com/watch?v=JU6sl_yyZqs
//const LoginPage=lazyLoad('./pages/LoginPage.jsx','Login')
//const LandingPage=lazy(()=>import('./pages/LandingPage.jsx'))

const queryClient = new QueryClient();

// const PrivateRoute = () => {
//   const isLoggedIn = localStorage.getItem("user_info") !== null;

//   if (!isLoggedIn) {
//     return <Navigate to="/" />;
//   }

//   return (
//     <div className="grid grid-cols-[22%_78%] min-h-screen bg-gray-50">
//       <SideBar />
//       <main className="flex-1 p-1 overflow-auto">
//         <Outlet />
//       </main>
//     </div>
//   );
// };

// Updated PrivateRoute component
const PrivateRoute = () => {
  const isLoggedIn = localStorage.getItem("user_info") !== null;

  if (!isLoggedIn) {
    return <Navigate to="/" />;
  }

  return <MobileNav />;
};

const PublicRoute = () => {
  return <Outlet />;
}

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          {/*<Route exact path="/" element={<RecordAudio />} />*/}
          <Route element={<PublicRoute />}>
            <Route exact path="/" element={<LoginPage />} />
            <Route exact path="/registration" element={<RegistrationPage />} />
            <Route exact path="/owner" element={<Owner />} />
            <Route exact path="/owner-landing" element={<OwnerLanding />} />
            <Route exact path="/owner/user-data" element={<VisualizeWellnessDataForOwner />} />
            <Route exact path="/owner/user-exercise-data" element={<VisualizeExerciseDataForOwner />} />
            <Route exact path="/email" element={<Email />} />
            <Route exact path="/payment-result" element={<PaymentResult />} />
            <Route exact path="/payment-success" element={<PaymentSuccess />} />
            <Route exact path="/payment-failure" element={<PaymentFailure />} />
            <Route exact path="/products" element={<Products />} />
            <Route exact path="/products/energyband-sales" element={<EnergyBandSales />} />
            <Route exact path="/products/semstetho-sales" element={<SemStethoSales />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route exact path="/on-exam" element={<OnExam />} />
            <Route exact path="/on-exam/video-exam" element={<VideoExam />} />
            <Route exact path="/on-exam/stetho" element={<Stetho />} />
            <Route exact path="/on-exam/bp" element={<BP />} />
            <Route path="/landing/*" element={<LandingPage />} />

            <Route path="/landing/tab1" element={<ChiefComplaints />} />
            {/*<Route path="/landing/tab2/*" element={<PrescriptionList />} />*/}
            <Route path="/landing/tab2/*" element={<MedicalDocument />} />
            {/* <Route path="/landing/tab3/*" element={<WellnessPages />} /> */}
            <Route path="/landing/tab3/*" element={<WellnessPage />} />
            <Route
              path="/landing/questionanswer"
              element={<QuestionnaireFormIntake />}
            />
            <Route
              path="/landing/pregnancyriskeval"
              element={<PregnancyRealTimeRiskEvalIntake />}
            />
            <Route path="/landing/cameracapture" element={<CameraCapture />} />
            <Route
              path="/landing/tab3/VisualizeWellnessData"
              element={<VisualizeWellnessData />}
            />
            <Route
              path="/browse-health-categories"
              element={<BrowseHealthCategories />}
            />
            <Route
              path="/health-categories/heart"
              element={<Heart />}
            />
            <Route
              path="/health-categories/activity"
              element={<Activity />}
            />
            <Route
              path="/health-categories/nutrition"
              element={<Nutrition />}
            />
            <Route
              path="/health-categories/nutrition/nutrition-summary"
              element={<VisualizeNutritionData />}
            />
            <Route
              path="/health-categories/sleep"
              element={<Sleep />}
            />
            <Route
              path="/health-categories/recovery"
              element={<Recovery />}
            />
            {/*<Route path="/landing/tab3/*" element={<VisualizeWellnessData />} />*/}
            <Route path="/landing/tab4" element={<Logout />} />
            <Route path={`/tab2/:itemName`} element={<Prescription />} />
            <Route path={`/tab3/:itemName`} element={<ReportPrint />} />
            <Route path="/landing/tab5" element={<RecordAudio />} />
            <Route path={`/tab2/Vitals`} element={<Vitals />} />
            {/* <Route path={`/tab2/Prescription`} element={<PrescriptionList />} /> */}
            <Route path={`/tab2/Prescription`} element={<MedicineList />} />
            {/* <Route path={`/tab2/Reports`} element={<ReportsList />} /> */}
            <Route path={`/tab2/Reports`} element={<ReportList />} />
            <Route path={`/tab2/Vitals/BP`} element={<BP />} />
            <Route path={`/chat`} element={<Chat />} />
            <Route path={"/payment"} element={<Payment />} />
            <Route path={"/consult-doctor"} element={<ConsultDoctor />} />
            <Route path={"/skin-disease"} element={<SkinDisease />} />
            <Route path={"/health-summary"} element={<VisualizaSummaryData />} />
            <Route path={"/profile"} element={<Profile />} />
            {/* <Route path={`/sidebar`} element={<SideBar />} /> */}
            {/*<Route path={`/tab3/Sleep`} element={<Sleep />} />*/}
          </Route>
        </Routes>
      </Router>
    </QueryClientProvider>
  );
};

export default App;
